import get from 'lodash/get';

const getYLabelOfPoint = (tooltipItem) => {
  const { yLabel } = tooltipItem[0];
  return yLabel || 0;
};

const getLabelOfDataPoint = (tooltipItem, data) => {
  const { index: labelIndex } = tooltipItem;
  const { labels } = data;
  return labels[labelIndex];
};

const getDateLabelOfPoint = getLabelOfDataPoint;
const getLabelOfPieSlice = getLabelOfDataPoint;

const getCountStatOfPieSlice = (tooltipItem, data) => {
  const { datasetIndex, index: dataIndex } = tooltipItem[0];
  const count = get(data, `datasets[${datasetIndex}].data[${dataIndex}]`);
  return count;
};

export {
  getYLabelOfPoint,
  getDateLabelOfPoint,
  getLabelOfPieSlice,
  getCountStatOfPieSlice,
};
